import s,{css as t}from"styled-components";import{BodyTextStyle as i}from"../typography/BodyText/index.js";import"react/jsx-runtime";import"../shared/media-queries.js";const l=(o,e)=>t`
  transform: translateY(${o});
  line-height: 0.875rem;
  font-size: 0.75rem;
  transform-origin: 0 0;
  padding: 0 5px;
  left: 0.5rem;
  color: ${({theme:r})=>e?r.colors.error.dark:r.colors.text.dark};
`,c=t`
  color: ${({theme:o,hasError:e})=>e?o.colors.error.dark:o.colors.text.dark};
`,n=t`
  color: ${({theme:o})=>o.colors.text.disabled};
`,d=t`
  width: max-content;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
`,h=s.label`
  ${i}
  pointer-events: none;
  position: absolute;
  max-width: calc(100% - 2rem);
  z-index: 1;
  top: ${({height:o})=>o?`calc(${o}rem - 5px)`:"12px"};
  left: calc(0.75rem + 2px);
  transition: 150ms;
  color: ${({theme:o})=>o.colors.text.dark};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: transparent;

  ${({theme:o,hasValue:e,isFocused:r})=>(e||r)&&`
  span {
    display: block;
    width: 100%;
    height: 8px;
    position: absolute;
    top: 6px;
    left: 0;
    background-color: ${o.colors.background.light};
    z-index: -1;
  }
  `}

  ${({hasValue:o,isFocused:e,height:r,hasError:a})=>(o||e)&&l(`${r?`calc(-${r}rem - 2px)`:"-18px"}`,a)}
  ${({centered:o,hasValue:e,isFocused:r})=>(e||r)&&o&&d}
  ${({isFocused:o})=>o&&c}
  ${({disabled:o})=>o&&n}
`;export{h as Label};
